import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { success } from 'assets/images';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

function WriteArticleForm() {
	const navigate = useNavigate();
	// Initialize Formik
	const formik = useFormik({
		initialValues: {
			fullName: '',
			email: '',
			topic: '',
			article: '',
		},
		validationSchema: Yup.object({
			fullName: Yup.string()
				.min(3, 'Must be 3 characters or more')
				.required('Required'),
			email: Yup.string().email('Invalid email address').required('Required'),
			topic: Yup.string()
				.min(3, 'Must be 3 characters or more')
				.required('Required'),
			article: Yup.string()
				.max(1000, 'Must be 1000 characters or less')
				.required('Required'),
		}),
		onSubmit: () => {
			axios({
				method: 'POST',
				url: 'http://localhost:5000/api/form/writeAnArticleForm',
				data: formik.values,
				headers: { 'Content-Type': 'multipart/form-data' },
			})
				.then(function (response) {
					console.log(response);
					Swal.fire({
						imageUrl: success,
						imageWidth: 100,
						imageHeight: 100,
						imageAlt: 'Success',
						title: 'Submitted Successfully',
						text: 'You have successfully filled the Write an Article Form.',
						width: 600,
						color: '#fff',
						padding: '3em',
						background: '#000',
						confirmButtonColor: '#800080',
						backdrop: 'rgba(255,255,255,0.3)',
					});
					navigate('/');
				})
				.catch(function () {
					Swal.fire({
						imageUrl: success,
						imageWidth: 100,
						imageHeight: 100,
						imageAlt: 'Success',
						title: 'Submission was Unsuccessful',
						text: 'Kindly try again.',
						width: 600,
						color: '#fff',
						padding: '3em',
						background: '#000',
						confirmButtonColor: '#800080',
						backdrop: 'rgba(255,255,255,0.3)',
					});
				});
		},
	});

	return (
		<>
			<h1 className='text-3xl text-center text-transparent font-semibold bg-clip-text bg-gradient-to-b from-purple to-gold pb-6 pt-4'>
				Share Your Story
			</h1>
			<form
				onSubmit={formik.handleSubmit}
				className='sm:py-8 md:py-8 lg:px-8 lg:py-8 xl:px-8 xl:py-8 2xl:px-8 2xl:py-8 mb-10 border-[#C52EC8] border-solid border-2'
			>
				{/* Full Name */}
				<div className='grid sm:px-4 md:px-10 lg:px-10 xl:px-10 2xl:px-10 m-4'>
					<label htmlFor='fullName' className='text-black text-base'>
						Full Name <b className='text-red text-base'>*</b>
					</label>
					<input
						name='fullName'
						type='text'
						className='p-1 rounded border-[#C52EC8] border-solid border-2 text-sm'
						placeholder='Enter your Full Name'
						onChange={formik.handleChange}
						value={formik.values.fullName}
					/>
					{formik.touched.fullName && formik.errors.fullName && (
						<div className='text-red text-base'>{formik.errors.fullName}</div>
					)}
				</div>

				{/* Email */}
				<div className='grid sm:px-4 md:px-10 lg:px-10 xl:px-10 2xl:px-10 m-4'>
					<label htmlFor='email' className='text-black text-base'>
						Email Address <b className='text-red text-base'>*</b>
					</label>
					<input
						name='email'
						type='email'
						className='p-1 rounded border-[#C52EC8] border-solid border-2 text-sm'
						placeholder='Enter your Email Address'
						onChange={formik.handleChange}
						value={formik.values.email}
					/>
					{formik.touched.email && formik.errors.email && (
						<div className='text-red text-base'>{formik.errors.email}</div>
					)}
				</div>

				{/* Topic */}
				<div className='grid sm:px-4 md:px-10 lg:px-10 xl:px-10 2xl:px-10 m-4'>
					<label htmlFor='topic' className='text-black text-base'>
						Topic <b className='text-red text-base'>*</b>
					</label>
					<input
						name='topic'
						type='text'
						className='p-1 rounded border-[#C52EC8] border-solid border-2 text-sm'
						placeholder='Enter your Topic Title'
						onChange={formik.handleChange}
						value={formik.values.topic}
					/>
					{formik.touched.topic && formik.errors.topic && (
						<div className='text-red text-base'>{formik.errors.topic}</div>
					)}
				</div>

				{/* Article */}
				<div className='grid sm:px-4 md:px-10 lg:px-10 xl:px-10 2xl:px-10 m-4'>
					<label htmlFor='article' className='text-black text-base'>
						Write an Article (Maximum 1000 words){' '}
						<b className='text-red text-base'>*</b>
					</label>
					<textarea
						name='article'
						className='p-1 rounded border-[#C52EC8] border-solid border-2 text-sm'
						rows='8'
						placeholder='Enter your Article (Max 1000 words)'
						onChange={formik.handleChange}
						value={formik.values.article}
					></textarea>
					{formik.touched.article && formik.errors.article && (
						<div className='text-red text-base'>{formik.errors.article}</div>
					)}
				</div>

				{/* Submit Button */}
				<div className='flex justify-center my-4'>
					<button
						type='submit'
						className='w-32 h-12 text-base bg-purple text-white rounded'
					>
						Submit Article
					</button>
				</div>
			</form>
		</>
	);
}

export default WriteArticleForm;
